import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default from 'react';
import styled from 'styled-components';
import Text from '../text/text.component.js';
import '../../utils/utils.js';
import '../../App.css.js';
var _excluded = ["style", "isMobile", "titleClassname", "onClick", "LinkComponent", "link", "subtitleColor", "image", "titleText", "captionText", "imageStyle"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var Div = styled.div.withConfig({
  displayName: "news-blockcomponent__Div",
  componentId: "sc-15vwrjp-0"
})(["& > * + *{margin-top:16px;}&:hover{img{transform:scale(1.02);transition:transform 0.3s ease 0s;}}"]);
var ImageNews = styled.img.withConfig({
  displayName: "news-blockcomponent__ImageNews",
  componentId: "sc-15vwrjp-1"
})(["width:100%;display:block;border-radius:16px;transition:transform 0.3s ease 0s;"]);
var TextTitle = styled(Text).withConfig({
  displayName: "news-blockcomponent__TextTitle",
  componentId: "sc-15vwrjp-2"
})(["@media screen and (max-width:768px){font-family:EuclidCircularA-Bold,Arial;font-weight:700;font-size:20px;line-height:28px;}"]);
var TextDescription = styled(Text).withConfig({
  displayName: "news-blockcomponent__TextDescription",
  componentId: "sc-15vwrjp-3"
})([""]);
var NewsBlock = function NewsBlock(_ref) {
  var style = _ref.style;
  _ref.isMobile;
  var titleClassname = _ref.titleClassname;
  _ref.onClick;
  var LinkComponent = _ref.LinkComponent,
    link = _ref.link,
    subtitleColor = _ref.subtitleColor,
    image = _ref.image,
    titleText = _ref.titleText,
    captionText = _ref.captionText,
    imageStyle = _ref.imageStyle;
  _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Div, {
    style: _objectSpread({
      display: "flex",
      flexDirection: "column"
    }, style)
  }, /*#__PURE__*/React__default.createElement(LinkComponent, {
    to: link,
    style: {
      width: "100%",
      textDecoration: "none"
    },
    rel: "nofollow"
  }, image ? /*#__PURE__*/React__default.createElement(ImageNews, {
    src: image,
    style: _objectSpread({
      marginBottom: "16px"
    }, imageStyle)
  }) : null, /*#__PURE__*/React__default.createElement(TextTitle, {
    className: titleClassname,
    fontFamily: "euclid",
    type: "heading",
    fontSize: "medium",
    tag: "h3",
    style: {
      marginBottom: "16px"
    }
  }, titleText), /*#__PURE__*/React__default.createElement(TextDescription, {
    fontFamily: "euclid",
    type: "label",
    fontSize: "small",
    color: subtitleColor
  }, captionText)));
};
export { NewsBlock as default };